export const MainTableColumns = [{
            key: 'employeeName',
            label: 'Name',
            sortable: true,
            sticky: "left",
            width: 150
        },
        {
            key: 'grossSalary',
            label: 'Gross Salary',
            sortable: true,
            width: '80px'
        },
        {
            key: 'daysWorked',
            label: 'Attendance',
            sortable: true,
            width: '100px'
        },
        {
            key: 'absents',
            label: 'Absents',
            sortable: true,
            width: '80px'
        },
        {
            key: 'obtainedLeaves',
            label: 'Leaves',
            sortable: true,
            width: '100px'
        },
        {
            key: 'lateDeduction',
            label: 'Late Deduction',
            sortable: true,
            width: '120px'
        },
        {
            key: 'extraAmountAdjustment',
            label: 'Adjustments',
            sortable: true,
            width: '160px'
        },
        {
            key: 'bonus',
            label: 'Bonus',
            sortable: true,
            width: '120px'
        },
        {
            key: 'finalAmount',
            label: 'Final Salary',
            sortable: true,
            width: '160px'
        },
        {
            key: 'taxDeduction',
            label: 'Tax',
            sortable: true,
            width: '160px'
        },
        {
            key: 'status',
            label: 'Status',
            sortable: true,
            width: '100px'
        },
        {
            key: 'action',
            label: 'Actions',
            width: 70,
            sticky: "right",
        },
    ];


// WEBPACK FOOTER //
// ./src/components/PayrollManagement/PayrollSummary/tableColumns.js